import React from 'react';
import styles from './styles.module.scss';

import { FormSelectInput } from 'components/FormComponents';

import { FormProvider, useForm } from 'react-hook-form';

import EditableContent from '../EditableContent';

export default function StatusCellContent({ row, onEdit, isEditable, statuses = [] }) {
  const { status } = row;

  const methods = useForm({
    defaultValues: {
      status
    }
  });
  const { setValue, getValues } = methods;

  const setDefaultValue = () => setValue('status', status);

  const selectStatus = ({ name, value }) => setValue(name, value);

  const handleAcceptClick = () => {
    onEdit({ ...row, status: getValues('status') });
  };

  return (
    <EditableContent
      onAccept={handleAcceptClick}
      isEditable={isEditable}
      setDefaultValue={setDefaultValue}
      hoverPencil
      renderDisplayedComponent={() => <>{status?.displayName || ''}</>}
      renderEditor={() => (
        <FormProvider {...methods}>
          <FormSelectInput
            enrichedByName
            name="status"
            options={statuses}
            onSelect={selectStatus}
            classes={styles.status__field}
          />
        </FormProvider>
      )}
    />
  );
}
